import { Calendar, Tag } from 'antd';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { SyncOutlined } from '@ant-design/icons';
import { randomHexColorGenerator } from '../../helpers/utils';

const CalendarComponent = ({ slotData }) => {
  const [colorMap, setColorMap] = useState({});

  const [selectedValue, setSelectedValue] = useState(() => {
    return slotData.forEach((item) => {
      if (item?.newSlot) {
        return moment(item.startDate).format('YYYY-MM-DD');
      }
    });
  });

  const [value, setValue] = useState(() => {
    const minStartDate = slotData.reduce(
      (minDate, item) => {
        const startDate = moment(item.startDate);
        return startDate.isBefore(minDate) ? startDate : minDate;
      },
      moment(moment(new Date()).format('YYYY-MM-DD')),
    );

    return minStartDate;
  });

  useEffect(() => {
    const newColorMap = {};
    slotData.forEach((item) => {
      newColorMap[item.id] = colorMap[item.id] || randomHexColorGenerator();
    });
    setColorMap(newColorMap);
  }, [slotData]);

  const onSelect = (newValue) => {
    setValue(newValue);
    setSelectedValue(newValue);
  };

  const onPanelChange = (newValue) => {
    setValue(newValue);
  };

  const getName = (item) => {
    if (item?.zone?.store?.code) {
      return `${item?.zone?.store?.code}-${item?.zone?.store?.name} / ${item.slotTemplate.name}`;
    }
    if (item.store.length > 0) {
      return item.store
        .map((store) => `${store.code}-${store.name}`)
        .join('/ ');
    } else {
      return `${item.slotTemplate.name}`;
    }
  };

  const dateCellRender = (value) => {
    return (
      <ul className="events">
        {slotData.map((item, index) => {
          const startDate = moment(item.startDate);
          const endDate = moment(item.endDate);

          if (value.isBetween(startDate, endDate, 'day', '[]')) {
            const color = colorMap[item.id];
            return (
              <div key={index}>
                <Tag
                  style={{ fontSize: 10, whiteSpace: 'break-spaces' }}
                  icon={item?.newSlot ? <SyncOutlined spin /> : null}
                  color={color}
                >
                  {getName(item)}
                </Tag>
              </div>
            );
          }

          return null;
        })}
      </ul>
    );
  };

  return (
    <Calendar
      value={selectedValue ?? value}
      dateCellRender={dateCellRender}
      onSelect={onSelect}
      onPanelChange={onPanelChange}
    />
  );
};

export default CalendarComponent;
